<template>
    <div class="user-status-bar-chart" :style="`height:${getHeight()}px`">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import { BarChart } from "echarts/charts";
import log2 from "../../../../../../utils/log2";
import { i18n } from "../../../../../../language";
import { dateToHourFromSecondsShortFormat } from "../../../../../../utils/filters";

echarts.use([BarChart]);

console.log("echarts", echarts);
Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=watermark

const log = log2("DoubleBarChart");
export default Vue.extend({
    name: "UserStatusBarChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart Title",
        },
        subTitle: {
            type: String,
            default: "",
        },
        userNames: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getHeight() {
            return Math.max(300, this.series[0]?.data?.length * 31 + 200);
        },
        getOptions() {
            const options = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },

                    valueFormatter: (value) => {
                        return dateToHourFromSecondsShortFormat(value * 60 * 60, this.$i18n.locale, true);
                    },
                },
                legend: {},
                color: [
                    "rgb(27, 197, 189)",
                    "rgb(54, 153, 255)",
                    "rgb(255, 168, 0)",
                    "rgb(246, 78, 96)",
                    "rgb(131,131,131)",
                ],
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: "none",
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ["line", "bar"] },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                title: [
                    {
                        text: this.title,
                        subtext: this.subTitle,
                        left: "14%",
                        textAlign: "center",
                    },
                ],
                grid: {
                    top: 50,
                    width: "100%",
                    height: "auto",
                    left: 30,
                    containLabel: true,
                },
                xAxis: {
                    type: "value",
                    show: false,
                },
                yAxis: {
                    type: "category",
                    data: this.userNames,
                },
                series: this.series,
            };
            log("options", options);
            return options;
        },
    },
});
</script>

<style scoped lang="scss">
.user-status-bar-chart {
    width: 100%;
    height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
